import { useEffect } from 'react';

export const useSelectInitialTemplate = (
  modes,
  isToolMixture,
  generationTool,
  selectedModeId,
  selectedModeType,
  onSelect
) => {
  useEffect(() => {
    // Clear template if modes are empty and return
    if (!modes.length) {
      onSelect({ selectedModeId: null, selectedModeType: null });
      return;
    }

    // Don't do anything if we have some mode from the list selected
    if (selectedModeId) {
      return;
    }

    const firstMode = modes[0];
    if (!firstMode) {
      return;
    }

    onSelect(firstMode);
  }, [selectedModeId, modes, selectedModeType, isToolMixture, generationTool, onSelect]);
};
